import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  purgeCacheForMultipleUrls: {
    method: 'POST',
    url: `${configs.wpWebhook}/purge-cache-urls`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const purgeCacheForMultipleUrls = async (urls) => {
  const res = await resource.purgeCacheForMultipleUrls({
    urls,
  })
  
  return res.body
}

export default {
  initResource,
  purgeCacheForMultipleUrls,
}